<template>
  <v-app>

    <!-- ALERT PANEL -->
    <v-overlay :value="alert">
      <v-alert
        prominent
        type="error"
        elevation="2"
      >
        <v-row align="center">
          <v-col class="grow">Are you sure you want to delete the selected item?</v-col>
          <v-col class="shrink">
            <v-btn outlined color="white" @click="toggleAlert">Cancel</v-btn>
          </v-col>
          <v-col class="shrink">
            <v-btn color="red darken-3" @click="deleteItem">Delete</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-overlay>

    <div class="notifications-container">
      <h2>User Groups</h2>
      <v-btn
        @click="createUserGroup"
        width="250"
        class="btn-create-notif mt-5"
        color="primary"
      >
        Create new user group
        <v-icon dark right size="large">mdi-plus</v-icon>
      </v-btn>

      <v-card class="notification-table mt-10">
        <v-card-title>
          {{ userGroups.length }} User Groups
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search user group by title"
            single-line
            hide-details
          />
        </v-card-title>

        <v-data-table
          v-if="userGroups"
          :headers="headers"
          :items="userGroups"
          :search="search"
          :loading="isLoading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.title="{ item }">
            <v-item-group>
              <v-item dark>
                <div>{{ item.title ? item.title : '--' }}</div>
              </v-item>
            </v-item-group>
          </template>
          <template v-slot:item.usercount="{ item }">
            <v-item-group>
              <v-item dark>
                <div>{{ item.usercount ? item.usercount : '--' }}</div>
              </v-item>
            </v-item-group>
          </template>
          <template v-slot:item.action="{ item }">
            <v-chip
              class="mr-2"
              color="blue"
              @click="updateUserGroup(item.userGroupId)"
            >
              <v-icon
                size="large"
                color="white"
              >
                mdi-pencil
              </v-icon>
            </v-chip>

            <v-chip
              color="error"
              @click="toggleAlert(item.userGroupId, item)"
            >
              <v-icon
                size="large"
                color="white"
              >
                mdi-trash-can
              </v-icon>
            </v-chip>
          </template>
          <template>
            <v-data-table item-key="title" class="elevation-1" loading loading-text="Loading... Please wait"/>
          </template>
          <template v-slot:no-data>
            <p class="mt-4">User group unavailable</p>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
  import userGroupsApi from '@/services/api/user-groups-api';

  export default {
    name: 'UserGroups',

    data: () => ({
      search: '',
      userGroups: [],
      headers: [
        { text: 'Group name', value: 'title' },
        { text: 'Number of users', value: 'usercount' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      editedIndex: -1,
      alert: false,
      deleteItemData: {
        userGroupId: null,
        item: null
      },
      isLoading: true
    }),

    async mounted() {
      // Chargement des user groups
      let data = await userGroupsApi.getAllUserGroups();
      this.userGroups = data.data;

      if (this.userGroups) {
        this.isLoading = false
      }
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    },

    methods: {
      createUserGroup() {
        this.$router.push({name: 'CreateUserGroup'});
      },

      updateUserGroup(id) {
        this.$router.push({ name: 'UpdateUserGroup', params: { id } });
      },

      toggleAlert(userGroupId, item) {
        this.deleteItemData.userGroupId = userGroupId;
        this.deleteItemData.item = item;
        this.alert = !this.alert;
      },

      deleteItem() {
        // On supprime l'item du tableau
        const index = this.userGroups.indexOf(this.deleteItemData.item);
        this.userGroups.splice(index, 1);

        // On supprime l'item dans la BDD
        userGroupsApi.deleteUserGroup(this.deleteItemData.userGroupId);

        // On réinitialise les données d'item à supprimer
        this.deleteItemData.userGroupId = null;
        this.deleteItemData.item = null;

        this.toggleAlert();
      },

      redirectToBack() {
        this.$router.back();
      }
    }
  };
</script>
